import { createFileRoute } from '@tanstack/react-router'

import { SETUP_STEPS, UploadSlot, WizardStep } from '@/components/onboarding'
import { DRINKS_MENU, EXTRA_MENUS, FOOD_MENU } from '@/mocks/onboarding/listky'

/** Before and after the lístky are handed over. */
type ListkySearch = { stav?: 'vyplneno' }

export const Route = createFileRoute('/onboarding/listky')({
  validateSearch: (search: Record<string, unknown>): ListkySearch =>
    search.stav === 'vyplneno' ? { stav: 'vyplneno' } : {},
  head: () => ({ meta: [{ title: 'Vaše lístky · Aplikace Bitez' }] }),
  component: OnboardingListky,
})

/**
 * The **standing** menus, and the last of everything we ask for — the most work
 * (a PDF from the designer, or a photo of a printed board) and the least urgent,
 * because until there is a post with a price in it, nobody needs them.
 *
 * Each lístek takes a file, a photo of the printed one, or a link — menus live
 * in all three places, and a client whose menu is only on their web would
 * otherwise stall on a step they cannot answer.
 *
 * The weekly one (polední menu) is a different animal: it changes every week and
 * becomes stories, so it is content and lives in the Plán.
 */
function OnboardingListky() {
  const { stav } = Route.useSearch()
  const filled = stav === 'vyplneno'

  return (
    <WizardStep
      step={4}
      steps={SETUP_STEPS}
      backHref="/onboarding/odkazy"
      nextHref="/klient/prehled"
      nextLabel="Hotovo"
      note="Bereme z nich položky a ceny do příspěvků — čerstvý lístek znamená přesnější obsah."
      skip={filled ? undefined : { label: 'Pošlu je později', href: '/klient/prehled' }}
    >
      <div className="space-y-8">
        <UploadSlot
          label="Jídelní lístek"
          hint="PDF, fotka nebo odkaz — jak ho máte po ruce."
          files={filled ? FOOD_MENU : []}
        />

        <UploadSlot
          label="Nápojový lístek"
          hint="Když je součástí jídelního, klidně ho přeskočte."
          files={filled ? DRINKS_MENU : []}
        />

        <UploadSlot
          label="Další lístky"
          hint="Vinný lístek, snídaně — cokoliv stálého, co u vás běží."
          files={filled ? EXTRA_MENUS : []}
          multiple
        />
      </div>
    </WizardStep>
  )
}
